import { Injectable } from '@angular/core';
import { State, StateToken, Action, StateContext } from '@ngxs/store';
import { RefreshState } from '../refresh/refresh-actions';
import { SetJobLocations } from './job-location-action';

export const JOB_LOCATION_TOKEN = new StateToken<any[]>('JobLocation');

@State({
    name: JOB_LOCATION_TOKEN,
    defaults: []
})
@Injectable()
export class JobLocationState {
    @Action(RefreshState)
    refresh(ctx: StateContext<any>, action: RefreshState) {
        if (action.data.name === JOB_LOCATION_TOKEN.getName()) {
            ctx.setState(action.data.state);
        }
    }

    @Action(SetJobLocations)
    set(ctx: StateContext<any>, action: SetJobLocations) {
        ctx.setState(action.data);
    }
}
